import { createSelector } from 'reselect';

const selectVouchers = (state: any) => state.vouchers;

export const selectVouchersCurrentItem = createSelector([selectVouchers], (vouchers) => vouchers.current);

export const selectVouchersListItems = createSelector([selectVouchers], (vouchers) => vouchers.list);

export const selectVouchersItemById = (itemId: any) =>
    createSelector(selectVouchersListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectVouchersQueryItems = createSelector([selectVouchers], (vouchers) => vouchers.query);

export const selectVouchersCreatedItem = createSelector([selectVouchers], (vouchers) => vouchers.create);

export const selectVouchersUpdatedItem = createSelector([selectVouchers], (vouchers) => vouchers.update);

export const selectVouchersReadItem = createSelector([selectVouchers], (vouchers) => vouchers.read);

export const selectVouchersDeletedItem = createSelector([selectVouchers], (vouchers) => vouchers.delete);

export const selectVouchersSearchedItems = createSelector([selectVouchers], (vouchers) => vouchers.search);

export const selectVouchersItemsCount = createSelector([selectVouchers], (vouchers) => vouchers.count);

export const selectVouchersItemsFilter = createSelector([selectVouchers], (vouchers) => vouchers.filter);